import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDygraphsComponent } from './ngx-dygraphs.component';
export class NgxDygraphsModule {
/**
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
    return {
      ngModule: NgxDygraphsModule
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    NgxDygraphsComponent
  ],
  exports: [
    NgxDygraphsComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxDygraphsModule_tsickle_Closure_declarations() {
/** @type {?} */
NgxDygraphsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxDygraphsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
